import { render, staticRenderFns } from "./SelectProducerOrGroup.vue?vue&type=template&id=58b9dfe8&scoped=true&"
import script from "./SelectProducerOrGroup.vue?vue&type=script&lang=js&"
export * from "./SelectProducerOrGroup.vue?vue&type=script&lang=js&"
import style0 from "./SelectProducerOrGroup.vue?vue&type=style&index=0&id=58b9dfe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b9dfe8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
